import { reducerCreator } from 'redux-rest-helper-for-loopback';
import { teamFormInitValues } from '../../forms/TeamForm';
import TeamsAction from './TeamsAction';

export default class TeamsReducer {
  private static initValues = teamFormInitValues;

  public static reducer = reducerCreator(TeamsAction.ENTRY, TeamsReducer.initValues).getReducer();
}
